import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { GridPaginationModel } from '@sbv-clients/ui-shared';

import {
  buildPaginationFiltersFactory,
  PAGINATION_STORAGE_KEY,
} from './utils/pagination-filters-factory';

export const usePaginationModel = () => {
  const [searchParams] = useSearchParams();

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(
    () =>
      buildPaginationFiltersFactory({
        loadDefault: searchParams.size > 0,
        fromSession: searchParams.size === 0,
      })
        .addNumberFilter('page', 0)
        .addNumberFilter('pageSize', 25)
        .build()
  );

  useEffect(() => {
    sessionStorage.setItem(
      PAGINATION_STORAGE_KEY,
      JSON.stringify(paginationModel)
    );
  }, [paginationModel]);

  return {
    paginationModel,
    setPaginationModel,
  };
};
